import { ThunkType } from "../../../../core/store/reducers";
import getSecurityStatisticsApi from "../api/getSecurityStatistics";
import { setDisplayedStatisatics } from "../statisticsDataSlice";
import { StockStatisticsItem, SecurityStatisticsApiResponse } from "../types";

// Load funkcija (reset + fetch)
export const loadSecurityStatistics = (
	symbol: string
): ThunkType => async (dispatch, getStore) => {
	// reset prethodnih podataka
	dispatch(setDisplayedStatisatics(undefined));

	console.log(symbol)


	const statistics = await dispatch(
		getSecurityStatisticss(symbol)
	);
	console.log(statistics)

	dispatch(setDisplayedStatisatics(statistics));
};

export const getSecurityStatisticss = (
	symbol: string
): ThunkType<Promise<StockStatisticsItem | undefined>> =>
	async (dispatch, getStore, _extra) => {

		const store = getStore();

		if (store.data.auth.current.status !== "successful") {
			return undefined;
		}

		const { userId } = store.data.auth.current.user;

		const response: SecurityStatisticsApiResponse | undefined =
			await dispatch(
				getSecurityStatisticsApi(userId, symbol, "statistics")
			);

		console.log(response)
		if (!response || !response.meta) {
			return undefined;
		}
		const { meta, statistics } = response;
		const { stock_price_summary, stock_statistics } = statistics;

		return {
			symbol: meta.symbol,
			beta: stock_price_summary.beta,
			fifty_two_week_high: stock_price_summary.fifty_two_week_high,
			fifty_two_week_low: stock_price_summary.fifty_two_week_low,
			avg_90_volume: stock_statistics.avg_90_volume,
			short_ratio: stock_statistics.short_ratio,
			day_50_ma: stock_price_summary.day_50_ma,
			day_200_ma: stock_price_summary.day_200_ma,
			shares_outstanding: stock_statistics.shares_outstanding,
			short_percent_of_shares_outstanding: stock_statistics.short_percent_of_shares_outstanding,
			percent_held_by_institutions: stock_statistics.percent_held_by_institutions,
		};
	};


